const statusTypeMap = {
  AWAITING_APPLICATION_FEE: { type: 'awaitingClient', label: 'Awaiting Application Fee' },
  NEW: { type: 'new', label: 'New' },
  ACCEPTED: { type: 'departmentAccepted', label: 'Accepted' },
  CLARIFYING_SCOPE: { type: 'awaitingClient', label: 'Clarifying Scope' },
  SCOPE_APPROVED: { type: 'ready', label: 'Scope Approved' },
  AWAITING_ESTIMATES: { type: 'awaitingDepartments', label: 'Awaiting Time Estimates' },
  ESTIMATES_RECEIVED: { type: 'ready', label: 'Time Estimates Received' },
  AWAITING_FEE_ESTIMATE: { type: 'awaitingClient', label: 'Pending Deposit' },
  FEE_ESTIMATE_PAID: { type: 'ready', label: 'Deposit Paid' },
  AWAITING_DOCUMENTS: { type: 'awaitingDepartments', label: 'Awaiting Records' },
  DOCUMENTS_RECEIVED: { type: 'ready', label: 'All Records Received' },
  REVIEW_READY: { type: 'ready', label: 'Ready for Final Review' },
  APPROVED: { type: 'ready', label: 'Reviewed & Approved' },
  AWAITING_INVOICE: { type: 'awaitingClient', label: 'Pending Payment' },
  INVOICE_PAID: { type: 'ready', label: 'Invoice Paid' },
  COMPLETED: { type: 'completed', label: 'Completed' },
  ABANDONED: { type: 'awaitingClient', label: 'Abandoned' },
  WITHDRAWN: { type: 'withdrawn', label: 'Withdrawn' }
}

const foiStatuses = Object.keys(statusTypeMap)
const nonAcceptedFoiStatuses = ['AWAITING_APPLICATION_FEE', 'NEW']
const completedFoiStatuses = ['COMPLETED', 'ABANDONED', 'WITHDRAWN']
const inProgressFoiStatuses = foiStatuses.filter(s => !completedFoiStatuses.includes(s))
const responsePageReadOnlyStatuses = [...completedFoiStatuses, 'INVALID']

const emptyRequestor = {
  requestor: {
    isBusiness: undefined,
    businessName: '',
    firstName: '',
    middleName: '',
    lastName: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    postalCode: '',
    province: '',
    unit: ''
  }
}

const emptyRequestDetails = {
  infoType: [],
  thirdPartyFiles: [],
  hasAddresses: undefined,
  addresses: [],
  requestDescription: '',
  accessMethod: ''
}

const emptyFoiInfo = {
  ...emptyRequestor,
  ...emptyRequestDetails
}

const foiStepperArray = ['Contact Information', 'Request Information', 'Review', 'Payment']

const getFoiStepperArray = (includePayment = false) => {
  if (includePayment) {
    return foiStepperArray
  }
  return foiStepperArray.slice(0, 3)
}

const applicantTypeMap = {
  COMMERCIAL: 'Commercial',
  PERSONAL: 'Individual'
}

const applicantTypeOptions = [
  { value: 'COMMERCIAL', label: 'Commercial' },
  { value: 'PERSONAL', label: 'Individual' }
]

const foiRequestorMaxUploadSizeMb = 20

const foiRequestorPayloadTooLargeMessage =
  `The total size of files in your request exceeds the ${foiRequestorMaxUploadSizeMb} MB limit for this form. ` +
  'Please remove or compress some files and try again.'

export {
  statusTypeMap,
  emptyRequestor,
  emptyRequestDetails,
  emptyFoiInfo,
  getFoiStepperArray,
  foiStatuses,
  nonAcceptedFoiStatuses,
  completedFoiStatuses,
  responsePageReadOnlyStatuses,
  inProgressFoiStatuses,
  applicantTypeMap,
  applicantTypeOptions,
  foiRequestorPayloadTooLargeMessage
}
